var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditProfileIcon = function SvgEditProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.35166,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9983 6.85724C10.9489 6.85724 6.85547 10.9506 6.85547 16.0001C6.85547 21.0496 10.9489 25.143 15.9983 25.143C21.0478 25.143 25.1412 21.0496 25.1412 16.0001C25.1412 10.9506 21.0478 6.85724 15.9983 6.85724ZM12.7983 12.8001C12.7983 11.0328 14.231 9.6001 15.9983 9.6001C17.7656 9.6001 19.1983 11.0328 19.1983 12.8001C19.1983 14.5674 17.7656 16.0001 15.9983 16.0001C14.231 16.0001 12.7983 14.5674 12.7983 12.8001ZM9.85268 19.9678C11.3601 18.7355 13.5615 17.8287 15.9984 17.8287C18.4352 17.8287 20.6366 18.7354 22.144 19.9677C20.8412 21.9816 18.5754 23.3144 15.9983 23.3144C13.4213 23.3144 11.1555 21.9816 9.85268 19.9678Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editProfileIcon.2e6a2267.svg";
export { ForwardRef as ReactComponent };